import { Component, OnInit } from '@angular/core';
import { Cliente } from '../comum/modelos/cliente';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    cliente: Cliente;
    constructor (private _cookieService: CookieService,
        public _authService: AuthService) {
        this.cliente = new Cliente();
    }
    ngOnInit() {
        this.cliente = JSON.parse(this._cookieService.get('cliente'));
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/home/home.component.ts